import { useCallback } from "react";
import Switch from "@coworker/apprestructured/src/task-management/components/Switch/Switch";
import { CreatorFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";

export type MarkAsCompleteCreatorFragmentConfigProps = EmptyObject;

type MarkAsCompleteCreatorFragmentProps = {
  configProps: MarkAsCompleteCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
};

function MarkAsCompleteCreatorFragment({
  commonProps,
}: MarkAsCompleteCreatorFragmentProps) {
  const { blockInput, task, onTaskChange } = commonProps;
  const state = getByPath(task, "state");
  const checked = state === "completed";

  const { t } = useTranslation();

  const handleCheckedChange = useCallback(
    (newChecked: boolean) => {
      onTaskChange({ state: newChecked ? "completed" : "pending" });
    },
    [onTaskChange]
  );

  if (isLoading(state)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <Switch
      checked={checked}
      onCheckedChange={handleCheckedChange}
      label={t("markAsCompleteString")}
      disabled={blockInput}
    />
  );
}

export default MarkAsCompleteCreatorFragment;
